import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext'
import { Form, Formik } from 'formik'
import { useEffect, useMemo, useRef, useState } from 'react'
import { AiFillCamera, AiOutlineLoading3Quarters } from 'react-icons/ai'
import {
  FiAlertTriangle,
  FiCalendar,
  FiCheck,
  FiChevronRight,
  FiEdit2,
  FiEye,
  FiFileText,
  FiImage,
  FiLink,
  FiLock,
  FiPlus,
  FiSave,
  FiTrash2,
  FiType,
  FiUsers,
  FiX,
} from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Avatar from '../Components/shared/chat/avatar'
import { InputFloatingLabel } from '../Components/shared/input'
import Modal from '../Components/shared/modal'
import UplaodProfile from '../Components/profileuplaod'
import {
  DoctorDetailsRequest,
  saveAvailablityRequest,
  UpdateDoctorDetailsRequest,
} from '../redux/actions/authActions'
import { getdoctorinfo, getPractitionerAvailableTimingsInfo } from '../redux/actions/passActions'
import { toastError, toastModal } from '../utils/helpers/methods'
import { getAddressSuggestions } from '../utils/services/geoapify'
import ProfileAvatar from '../utils/helpers/ProfileAvatar'
import { Row } from '../utils/helpers/Row'
import { QuickAction } from '../utils/helpers/QuickAction'
import AddPredefinedMessage from '../Components/payment/addPredefinedMessageForm'
import { getPredefineMessageFileType } from '../utils/helpers/predefinedMessageSupport'
import { medicalSpecality } from '../utils/helpers/medicalSpecality'
import { LanguageOptionList } from '../utils/helpers/languagePreference'
import { MultiSelectFloatingLabel } from '../Components/shared/input/multiSelectDropdown'
import { DAYS_OF_WEEK, DEFAULT_WORKDAY_START, DEFAULT_WORKDAY_END, WEEKEND_KEYS, normalizeSlots, getSlotErrors, TIME_OPTIONS, createSlotId } from '../utils/helpers/profileConstant'
const formatPhoneNumber = (value) => {
  if (!value) return value
  const phoneNumber = value.replace(/[^\d]/g, '')
  const phoneNumberLength = phoneNumber.length

  if (phoneNumberLength < 4) return phoneNumber
  if (phoneNumberLength < 7)
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`

  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
}

const PERSONAL_INFO_FIELDS = ['name', 'phone_number', 'gender', 'speciality']
const ADDRESS_FIELDS = ['address_line1', 'address_city', 'address_state', 'address_zip']
const REQUIRED_FIELDS = [...PERSONAL_INFO_FIELDS, ...ADDRESS_FIELDS]
const FIELD_LABELS = {
  name: 'full name',
  phone_number: 'phone number',
  address_line1: 'address',
  address_city: 'city',
  address_state: 'state',
  address_zip: 'zip code',
  title: 'title',
  gender: 'gender',
  speciality: 'medical speciality',
}

const validateProfileForm = (values) => {
  const errors = {}
  const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/

  if (!values.name) {
    errors.name = 'Full name is required'
  }

  if (!values.phone_number) {
    errors.phone_number = 'Phone number is required'
  } else if (!phoneRegex.test(values.phone_number)) {
    errors.phone_number = 'Must be a valid US phone number, e.g. (555) 555-5555'
  }

  if (!values.title) {
    errors.title = 'Title is required for prescription authority display'
  }

  if (!values.gender) {
    errors.gender = 'Gender is required'
  }

  if (!values.speciality) {
    errors.speciality = 'Medical speciality is required'
  }

  if (!values.address_line1) {
    errors.address_line1 = 'Address line 1 is required'
  }

  if (!values.address_city) {
    errors.address_city = 'City is required'
  }

  if (!values.address_state) {
    errors.address_state = 'State is required'
  }

  if (!values.address_zip) {
    errors.address_zip = 'Zip code is required'
  }

  return errors
}

const TABS = [
  { id: 'personal', label: 'Personal info' },
  { id: 'address', label: 'Practice address' },
  { id: 'availablity', label: 'Availablity Info' },
  { id: 'system', label: 'System info' },
]

const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
]
const Profile = () => {
  const { docinfo } = useSelector((state) => state.pass)
  const store = useSendbirdStateContext()
  var sdk = store?.stores.sdkStore.sdk
  var geoKey = process.env.REACT_APP_GEOAPIFY_KEY
  const [openModal, setOpenModal] = useState(false)
  const [previewOpen, setPreviewOpen] = useState(false)
  const [file, setFile] = useState([])
  const [imageUrl, setImageUrl] = useState('')
  const [firstName, setFirstName] = useState('')
  const [secondName, setSecondName] = useState('')
  const [activeTab, setActiveTab] = useState('personal')

  const debounceTimer = useRef(null)
  const [suggestions, setSuggestions] = useState([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [isSearching, setIsSearching] = useState(false)
  const [showAddressHint, setShowAddressHint] = useState(false)
  const [show,setShow]=useState(false);
  const [row,setRow]=useState("");

  const formikRef = useRef(null)

  const dispatch = useDispatch();

  const { userToken, userInfo, doctorDetails, updateDetails ,availablity} = useSelector(
    (state) => state.auth
  )
  const [shortcuts, setShortcuts] = useState([] );
  const [isSavingAvailability, setIsSavingAvailability] = useState(false)
  const [onboardingSlot, setOnboardingSlot] = useState({
      start: DEFAULT_WORKDAY_START,
      end: DEFAULT_WORKDAY_END,
  })
  const [availabilityOnboardingDismissed, setAvailabilityOnboardingDismissed] = useState(false)
  const [availabilityState, setAvailabilityState] = useState({
    hasFetchedAvailability: false,
    hasAnySavedAvailability: false,
    showAvailabilityOnboarding: false,
  });
  const patientCount = useSelector( (state) => state.patients?.list?.length ?? state.patients?.data?.length
)
useEffect(() => {
  const hasFetchedAvailability = Boolean(availablity?.data);

  if (!hasFetchedAvailability) {
    setAvailabilityState({
      hasFetchedAvailability: false,
      hasAnySavedAvailability: false,
      showAvailabilityOnboarding: false,
    });

    return;
  }

  const hasAnySavedAvailability = DAYS_OF_WEEK.some((day) => {
    const slots =
      availablity.data?.[`${day.key}_available_time`];

    return Array.isArray(slots) && slots.length > 0;
  });

  const showAvailabilityOnboarding =
    !hasAnySavedAvailability &&
    !availabilityOnboardingDismissed;

  setAvailabilityState({
    hasFetchedAvailability: true,
    hasAnySavedAvailability,
    showAvailabilityOnboarding,
  });
  if (hasAnySavedAvailability && availabilityOnboardingDismissed) {
    setAvailabilityOnboardingDismissed(false);
  }
}, [availablity, availabilityOnboardingDismissed]);
 

  const initialValues = useMemo(
    () => ({
      name: doctorDetails?.data?.name,
      phone_number: formatPhoneNumber(
        doctorDetails?.data?.location?.phone_number || "",
      ),
      address_line1: doctorDetails?.data?.location?.address_line1,
      address_line2: doctorDetails?.data?.location?.address_line2,
      address_city: doctorDetails?.data?.location?.address_city,
      address_state: doctorDetails?.data?.location?.address_state,
      address_zip: doctorDetails?.data?.location?.address_zip,
      title: doctorDetails?.data?.title || '',
      speciality: doctorDetails?.data?.speciality || '',
      gender: doctorDetails?.data?.gender || '',
      available_time: DAYS_OF_WEEK.reduce((acc, day) => {
        const rawSlots = availablity?.data?.[`${day.key}_available_time`]
        acc[day.key] = Array.isArray(rawSlots) ? normalizeSlots(rawSlots) : []
        return acc
      }, {}),
      preference_lang: doctorDetails?.data?.preference_lang || [],
    }),
    [doctorDetails?.data, availablity?.data]
  )
const tagIcon = {
  image: <FiImage size={12} />,
  link: <FiLink size={12} />,
  document: <FiFileText size={12} />,
}
  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current)
      }
    };
  }, []);
  useEffect(() => {
    dispatch(DoctorDetailsRequest({ id: userInfo?.id }));
    dispatch(getdoctorinfo({ token: userToken, docid: userInfo.id }));
    // dispatch(getPractitionerAvailableTimingsInfo({token: userToken, id: userInfo?.id })) //since we are fetching from app.js
  }, [])
  useEffect(() => {
    setShortcuts(doctorDetails?.data?.text_shortcuts || []);
  }, [doctorDetails])
  async function UpdateSendbird(res) {
    const params = {
      nickname: res?.data?.data?.sendbird_name,
      profileUrl: res?.data?.data?.profile_image,
    }
    const metaData ={
      patient:"false"
    }
    await sdk.updateCurrentUserInfo(params).then((rev) => {
      console.log('updated ....')
    })
    await sdk.currentUser.createMetaData(metaData).then(()=>{
      console.log('updated metadata ok ....')
    }).catch(err=>console.log({err}))
    
  }

  function success() {
    dispatch(
      getdoctorinfo({
        token: userToken,
        docid: userInfo.id,
        success: UpdateSendbird,
      })
    )
    dispatch(DoctorDetailsRequest({ id: userInfo?.id }))
    toastModal('Profile Updated Succesfully')
  }
  function availabilitySuccess() {
    toastModal('Availability Updated Succesfully')
  }
 const saveAvailablity = (formValues) => {
    if (isSavingAvailability) return

    const hasErrors = DAYS_OF_WEEK.some((day) => {
      const errors = getSlotErrors(formValues.available_time?.[day.key] || [])
      return Object.keys(errors).length > 0
    })
    if (hasErrors) {
      toastError('Fix the highlighted slot conflicts before saving availability')
      return
    }

    setIsSavingAvailability(true)
    const availabilityPayload = DAYS_OF_WEEK.reduce((acc, day) => {
      acc[`${day.key}_available_time`] = (
        formValues.available_time?.[day.key] || []
      ).map((slot) => ({
        start_time: slot.start ? `${slot.start}:00` : '',
        end_time: slot.end ? `${slot.end}:00` : '',
      }))
      return acc
    }, {})

    const stopSaving = () => setIsSavingAvailability(false)

    dispatch(
      saveAvailablityRequest({
        data: { ...availabilityPayload, practitioner_id: userInfo?.id },
        success: () => {
          stopSaving()
          availabilitySuccess();
          dispatch(getPractitionerAvailableTimingsInfo({token: userToken, id: userInfo?.id }))
        },
        error: () => {
          stopSaving()
          toastModal('Failed to save availability. Please try again.')
        },
      })
    )
    setTimeout(stopSaving, 15000)
  }
  
  const onSubmit = async (values) => {
    const formData = new FormData()
    formData.append('name', values.name)
    formData.append('profile_img', file)
    formData.append('phone_number', values.phone_number)
    formData.append('address_line1', values.address_line1)
    formData.append('address_line2', values.address_line2)
    formData.append('address_city', values.address_city)
    formData.append('address_state', values.address_state)
    formData.append('address_zip', values.address_zip)
    formData.append('title', values.title)
    formData.append('speciality', values.speciality)
    formData.append('gender', values.gender)
    formData.append('preference_lang', values.preference_lang)
    formData.append(
      'practitioner_id',
      doctorDetails?.data?.doctor_login?.practitioner_id
    );
    dispatch(UpdateDoctorDetailsRequest({ data: formData, success }))
  }

  useEffect(() => {
    if (docinfo) {
      const [firstLetter, secondletter] = docinfo?.name
        ?.split(' ')
        .map((part) => part.charAt(0).toUpperCase())
      setFirstName(firstLetter)
      setSecondName(secondletter)
    }
  }, [docinfo])
  const handleAddressChange = (e, setFieldValue) => {
    const val = e.target.value
    setFieldValue('address_line1', val)

    if (val.length > 0) {
      setIsSearching(true)
      if (debounceTimer.current) clearTimeout(debounceTimer.current)

      debounceTimer.current = setTimeout(async () => {
        try {
          const features = await getAddressSuggestions(val, geoKey)
          setSuggestions(features)
          setShowSuggestions(true)
        } catch (err) {
          setSuggestions([])
        } finally {
          setIsSearching(false)
        }
      }, 300)
    } else {
      setSuggestions([])
      setShowSuggestions(false)
      setIsSearching(false)
    }
  }

  const {
    completeness,
    missingFields,
    personalCompleteness,
    addressCompleteness,
  } = useMemo(() => {
    const scoreSection = (fields) => {
      const missing = fields.filter((key) => {
        const value = initialValues[key]
        return value === undefined || value === null || value === ''
      })
      const pct = Math.round(((fields.length - missing.length) / fields.length) * 100)
      return { missing, pct }
    }
 
    const personal = scoreSection(PERSONAL_INFO_FIELDS)
    const address = scoreSection(ADDRESS_FIELDS)
    return {
      completeness: Math.round((personal.pct + address.pct) / 2),
      missingFields: [...personal.missing, ...address.missing],
      personalCompleteness: personal.pct,
      addressCompleteness: address.pct,
    }
  }, [doctorDetails])

  const missingTitle = !initialValues.title
  const missingGender = !initialValues.gender
  const missingSpecialty = !initialValues.speciality
  const personalIncomplete = missingTitle || missingGender || missingSpecialty
  const addressIncomplete =
    !initialValues.address_line1 ||
    !initialValues.address_city ||
    !initialValues.address_state ||
    !initialValues.address_zip

  const addShortcut = () => {
    setShow(true);
  }

  const removeShortcut = (id) => {
    setShortcuts((prev) => prev.filter((s) => s.id !== id))
  }
  const SHORTCUTS_PREVIEW_COUNT = 3
  const visibleShortcuts = shortcuts.slice(0, SHORTCUTS_PREVIEW_COUNT)
  const remainingShortcutsCount = Math.max(
    shortcuts.length - SHORTCUTS_PREVIEW_COUNT,
    0
  )

  return (
    <div className='h-[100%] bg-gray-50/40'>
      {/* Breadcrumb + page header */}
      <div className='flex items-start justify-between p-4 pb-0 flex-wrap gap-3'>
        <div>
          <p className='text-xs font-semibold tracking-wide text-everglade-700 uppercase flex items-center gap-1'>
            <span className='bg-everglade-600 inline-block' />
            Settings <FiChevronRight size={12} /> Profile
          </p>
          <h1 className='text-[25px] font-bold text-gray-900 mt-1'>
            Practitioner Profile
          </h1>
          <p className='text-sm text-gray-500 mt-1'>
            Manage your personal information, address, and predefined message
          </p>
        </div>
        <div className='flex items-center gap-3'>
          <button
            type='button'
            onClick={() => setPreviewOpen(true)}
            className='flex items-center gap-2 border border-gray-300 rounded-md px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50'
          >
            <FiEye size={16} /> Preview card
          </button>
          <button
            type='button'
            onClick={() => formikRef.current?.handleSubmit()}
            className='flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-everglade-800 hover:bg-everglade-700'
          >
            <FiSave size={16} />
            {updateDetails?.loading ? 'Saving...' : 'Save changes'}
          </button>
        </div>
      </div>

      {/* Profile completeness banner */}
        <div className='m-4 border border-gray-200 bg-white rounded-lg p-4 flex items-center gap-4'>
        <div className='w-10 h-10 rounded-lg bg-everglade-50 flex items-center justify-center text-everglade-700 shrink-0'>
          <FiUsers size={20} />
        </div>
        <div className='flex-1 min-w-[200px]'>
          <div className='flex items-center justify-between'>
            <span className='font-semibold text-gray-800 text-sm'>
              Profile completeness
            </span>
            <span className='font-semibold text-everglade-700 text-sm'>
              {completeness}%
            </span>
          </div>
          <div className='w-full h-2 bg-gray-200 rounded-full mt-2 overflow-hidden'>
            <div
              className='h-full bg-everglade-600 rounded-full transition-all'
              style={{ width: `${completeness}%` }}
            />
          </div>
          {completeness < 100 && missingFields.length > 0 && (
            <p className='text-xs text-amber-600 flex items-center gap-1 mt-2'>
              <FiAlertTriangle size={12} />
              Add your{' '}
              {missingFields.map((f) => FIELD_LABELS[f] || f).join(', ')} to
              reach 100% — incomplete profiles reduce patient discoverability
            </p>
          )}
        </div>
        <button
          type='button'
          onClick={() => setActiveTab('personal')}
          className='text-sm font-medium text-everglade-700 hover:underline flex items-center gap-1 shrink-0'
        >
          Complete now <FiChevronRight size={14} />
        </button>
      </div>
      <div className='flex flex-row flex-wrap gap-4 px-4 pb-4'>
        {/* Left column: profile card + quick actions */}
        <div className='w-full lg:w-[320px] flex flex-col gap-4'>
          <div className='rounded-lg shadow-sm border border-gray-200 overflow-hidden bg-white'>
            <div className='w-full py-8 bg-gradient-to-b to-everglade-200 from-everglade-700 flex flex-col justify-center items-center relative'>
              <div className='relative'>
                <ProfileAvatar
                  image={imageUrl || doctorDetails?.data?.profile_image}
                  firstName={firstName}
                  lastName={secondName}
                  editable
                  onEdit={() => setOpenModal(true)}
                />
                <button
                  type='button'
                  onClick={() => setOpenModal(true)}
                  className='absolute bottom-0 right-0 bg-everglade-600 border-2 border-white rounded-full w-7 h-7 flex items-center justify-center text-white hover:bg-everglade-700'
                  aria-label='Change profile photo'
                >
                  <AiFillCamera size={14} />
                </button>
              </div>
              <h1 className='text-white font-bold tracking-wide text-lg capitalize mt-3'>
                {docinfo?.name}
              </h1>
              <p className='text-everglade-100 text-sm capitalize'>
                {doctorDetails?.data?.title || 'Practitioner'}
              </p>
              <span className='mt-2 text-xs font-medium bg-white/20 text-white rounded-full px-3 py-1 flex items-center gap-1'>
                <span className='w-1.5 h-1.5 rounded-full bg-emerald-300' />
                Active · Available
              </span>
            </div>

            <div className='p-4 flex flex-col gap-3 text-sm'>
              <Row label='Practitioner ID' value={docinfo?.id} mono={true} />
              <Row label='Sendbird ID' value={sdk?.currentUser?.userId || '—'} mono={true}/>
              <Row label='Email' value={docinfo?.email_address} breakAll />
              <Row label='Gender' value={doctorDetails?.data?.gender || docinfo?.gender} />
              <Row label='Phone' value={docinfo?.location?.phone_number} />
              <Row label='Admin Groups' value={doctorDetails?.data?.sendbird_admin?.join(', ')} mono={true} />
              {Array.isArray(doctorDetails?.data?.admin_groups) &&
                doctorDetails.data.admin_groups.length > 0 && (
                  <div className='flex items-start justify-between gap-2'>
                    <span className='text-gray-500 uppercase text-xs tracking-wide pt-1'>
                      Admin groups
                    </span>
                    <div className='flex flex-wrap gap-1 justify-end'>
                      {doctorDetails.data.admin_groups.map((g) => (
                        <span
                          key={g}
                          className='text-xs font-medium bg-everglade-50 text-everglade-800 rounded-full px-2 py-0.5'
                        >
                          {g}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
            </div>
          </div>

          {/* Quick actions */}
          <div className='rounded-lg shadow-sm border border-gray-200 bg-white p-2'>
            <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide px-2 py-2'>
              Quick actions
            </p>
            <QuickAction
              to='/chat?broadcast=true'
              icon={<FiUsers size={18} />}
              title='Send message'
              subtitle='Connect with your patients'
            />
            <QuickAction
              to='/patientList'
              icon={<FiUsers size={18} />}
              title='View my patients'
              subtitle={
                typeof patientCount === 'number'
                  ? `${patientCount} active patients assigned`
                  : 'View your assigned patients'
              }
            />
            <QuickAction
              to='/predefined'
              icon={<FiFileText size={18} />}
              title='Manage templates'
              subtitle={`${shortcuts.length} text shortcuts configured`}
            />
            <QuickAction
              to='/setting/change-password'
              icon={<FiLock size={18} />}
              title='Change password'
              subtitle='Update your account password'
            />
          </div>
        </div>

        {/* Right column: tabbed form */}
        <div className='flex-1 min-w-[320px] rounded-lg shadow-sm border border-gray-200 bg-white'>
          <div className='flex border-b border-gray-200 px-4 overflow-x-auto'>
            {TABS.map((tab) => (
              <button
                key={tab.id}
                type='button'
                onClick={() => setActiveTab(tab.id)}
                className={`relative flex items-center gap-1 px-4 py-3 text-sm font-medium whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'text-everglade-800 border-b-2 border-everglade-700'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                {tab.label}
                {tab.id === 'personal' && personalIncomplete && (
                  <span className='w-1.5 h-1.5 rounded-full bg-amber-500 ml-0.5' />
                )}
                {tab.id === 'address' && addressIncomplete && (
                  <span className='w-1.5 h-1.5 rounded-full bg-amber-500 ml-0.5' />
                )}
              </button>
            ))}
          </div>

          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            enableReinitialize={true}
            validate={validateProfileForm}
            onSubmit={onSubmit}
          >
            {({ setFieldValue, values, handleChange,handleBlur }) => {

              return (
              <Form>
                {activeTab === 'personal' && (
                  <div className='p-6'>
                    <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4'>
                      Basic details
                    </p>
                    
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4'>
                        <InputFloatingLabel name='name' label='Full name' />

                        <InputFloatingLabel
                          name='title'
                          label='Title'
                        />

                        <InputFloatingLabel
                          name='email_display'
                          label='Email address'
                          value={docinfo?.email_address || ''}
                          disabled
                        />

                        <InputFloatingLabel
                          name='phone_number'
                          label='Phone number'
                          onChange={(e) => {
                            const formatted = formatPhoneNumber(e.target.value)
                            setFieldValue('phone_number', formatted)
                          }}
                        />

                        <InputFloatingLabel
                          as='select'
                          name='gender'
                          label='Gender'
                          options={GENDER_OPTIONS}
                        />

                        <InputFloatingLabel
                          as='select'
                          name='speciality'
                          label='Medical speciality'
                          options={medicalSpecality}
                        />
                      </div>
                    {/* predefined Message*/}
                    <div className='mt-8 border-t border-gray-100 pt-6'>
                      <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3'>
                        Predefined Message Template
                      </p>
                      <div className='border border-gray-200 rounded-lg p-4'>
                      <div className='flex flex-col gap-2'>
                        {visibleShortcuts.map((s) => {
                          const tag = getPredefineMessageFileType(s);
                          return (
                            <div
                              key={s.id}
                              className='flex items-center justify-between border border-gray-200 rounded-md px-3 py-2'
                            >
                              <div className='flex items-center gap-3 min-w-0'>
                                <span className='text-xs font-mono bg-everglade-50 text-everglade-800 rounded px-2 py-1 shrink-0'>
                                  {s.key_word}
                                </span>
                                <span className='text-sm text-gray-700 truncate'>
                                  {s.message}
                                </span>
                              </div>
                              <div className="flex items-center gap-2 shrink-0">
                                {tag.map((t) => (
                                  <span
                                    key={t.key}
                                    className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ${t.className}`}
                                  >
                                    {t.icon}
                                    {t.label}
                                  </span>
                                ))}

                                <button
                                  type="button"
                                  className="text-gray-400 hover:text-gray-600"
                                >
                                  <FiEdit2 size={14} />
                                </button>

                                <button
                                  type="button"
                                  onClick={() => removeShortcut(s.id)}
                                  className="text-gray-400 hover:text-red-500"
                                >
                                  <FiTrash2 size={14} />
                                </button>
                              </div>
                            </div>
                          )
                        })}
                        <button
                          type='button'
                          onClick={addShortcut}
                          className='flex items-center justify-center gap-2 border border-dashed border-gray-300 rounded-md py-2 text-sm text-gray-500 hover:border-everglade-400 hover:text-everglade-700'
                        >
                          <FiPlus size={14} /> Add
                        </button>
                          {remainingShortcutsCount > 0 && (
                            <Link
                              to='/predefined'
                              className='flex items-center justify-center gap-2 border border-gray-200 rounded-md py-2 text-sm text-everglade-700 font-medium hover:bg-everglade-50'
                            >
                              Show {remainingShortcutsCount} more{' '}
                              <FiChevronRight size={14} />
                            </Link>
                          ) }
                      </div>
                      </div>
                    </div>

                  
                    
                      <div className='mt-8 border-t border-gray-100 pt-6'>
                        <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3'>
                          Preferences
                        </p>
                        <div className='border border-gray-200 rounded-lg p-4'>
                          <div className='flex flex-col gap-4'>
                            <MultiSelectFloatingLabel
                              label='Language'
                              value={values.preference_lang || []}
                              onChange={(langs) => { console.log(langs); setFieldValue('preference_lang', langs) }}
                              options={LanguageOptionList}
                              placeholder='e.g. English, Spanish'
                            />
                          </div>
                        </div>

                        <p className='text-xs text-gray-400 mt-2'>
                          These fields save together with the rest of the
                          form via "Save changes" above.
                        </p>
                      </div>
                    </div>
                )}
                {activeTab === 'availablity' && (
                <div className='p-6'>
                    <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4'>
                         Availability & preferences
                    </p>
                    {!availabilityState.hasFetchedAvailability ? (
                      <div className='flex items-center gap-2 text-sm text-gray-500 py-6'>
                        <AiOutlineLoading3Quarters
                          className='animate-spin text-everglade-700'
                          size={16}
                        />
                        Loading availability…
                      </div>
                    ) : availabilityState.showAvailabilityOnboarding ? (
                      <div className='border border-gray-200 rounded-lg p-6 text-center max-w-md mx-auto'>
                        <p className='text-sm font-semibold text-gray-800 mb-1'>
                          No available schedule is updated
                        </p>
                        <p className='text-xs text-gray-500 mb-5'>
                          Set your default working hours to quickly configure
                          your weekly availability.
                        </p>
                        <div className='flex items-center justify-center gap-3 mb-4'>
                          <div className='text-left'>
                            <label className='block text-xs text-gray-500 mb-1'>
                              Default start time
                            </label>
                            <select
                              value={onboardingSlot.start}
                              onChange={(e) =>
                                setOnboardingSlot((prev) => ({
                                  ...prev,
                                  start: e.target.value,
                                }))
                              }
                              className='border border-gray-300 rounded-md px-2 py-1.5 text-sm text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-everglade-500 focus:border-everglade-500'
                            >
                              {TIME_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className='text-left'>
                            <label className='block text-xs text-gray-500 mb-1'>
                              Default end time
                            </label>
                            <select
                              value={onboardingSlot.end}
                              onChange={(e) =>
                                setOnboardingSlot((prev) => ({
                                  ...prev,
                                  end: e.target.value,
                                }))
                              }
                              className='border border-gray-300 rounded-md px-2 py-1.5 text-sm text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-everglade-500 focus:border-everglade-500'
                            >
                              {TIME_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {onboardingSlot.start >= onboardingSlot.end && (
                          <p className='text-xs text-red-600 mb-3 flex items-center justify-center gap-1'>
                            <FiAlertTriangle size={12} /> End time must be after
                            start time
                          </p>
                        )}

                        <button
                          type='button'
                          disabled={onboardingSlot.start >= onboardingSlot.end}
                          onClick={() => {
                            const updated = DAYS_OF_WEEK.reduce((acc, day) => {
                              // Monday–Friday only.
                              acc[day.key] = WEEKEND_KEYS.includes(day.key)
                                ? []
                                : [
                                    {
                                      id: createSlotId(),
                                      start: onboardingSlot.start,
                                      end: onboardingSlot.end,
                                    },
                                  ]
                              return acc
                            }, {})
                            setFieldValue('available_time', updated)
                            setAvailabilityOnboardingDismissed(true)
                          }}
                          className='border-2 border-everglade-700 bg-everglade-700 hover:border-everglade-400 hover:bg-everglade-400 disabled:opacity-50 disabled:cursor-not-allowed rounded px-5 py-2 text-sm font-medium text-white uppercase'
                        >
                          Set default schedule
                        </button>
                      </div>
                    ) : (
                    <div >
                        <div className='border border-gray-200 rounded-lg p-4 mb-4'>
                          <div className='flex items-center justify-between mb-3 flex-wrap gap-2'>
                            <p className='text-sm font-semibold text-gray-800'>
                              Weekly working hours
                            </p>
                            <button
                              type='button'
                              onClick={() => {
                                const mondaySlots = values.available_time?.monday || []
                                if (mondaySlots.length === 0) return
                                const updated = DAYS_OF_WEEK.reduce((acc, day) => {
                                  acc[day.key] = mondaySlots.map((slot) => ({
                                    ...slot,
                                    id: createSlotId(),
                                  }))
                                  return acc
                                }, {})
                                setFieldValue('available_time', updated)
                              }}
                              className='text-xs font-medium text-everglade-700 hover:underline'
                            >
                              Copy Monday's slots to every day
                            </button>
                          </div>

                          <div className='flex flex-col divide-y divide-gray-100'>
                            {DAYS_OF_WEEK.map((day) => {
                              const daySlots = values.available_time?.[day.key] || []
                              const slotErrors = getSlotErrors(daySlots)

                              const addSlot = () => {
                                const last = daySlots[daySlots.length - 1]
                                setFieldValue(`available_time.${day.key}`, [
                                  ...daySlots,
                                  {
                                    id: createSlotId(),
                                    start: last?.end || DEFAULT_WORKDAY_START,
                                    end: DEFAULT_WORKDAY_END,
                                  },
                                ])
                              }

                              const removeSlot = (slotId) => {
                                setFieldValue(
                                  `available_time.${day.key}`,
                                  daySlots.filter((s) => s.id !== slotId)
                                )
                              }

                              const updateSlot = (slotId, field, val) => {
                                console.log('updateSlot',day.key,slotId,field,val)
                                setFieldValue(
                                  `available_time.${day.key}`,
                                  daySlots.map((s) =>
                                    s.id === slotId ? { ...s, [field]: val } : s
                                  )
                                )
                              }

                              return (
                                <div key={day.key} className='py-3'>
                                  <div className='flex items-center justify-between gap-3 mb-2'>
                                    <span className='text-sm font-medium text-gray-700 w-28 shrink-0'>
                                      {day.label}
                                    </span>
                                    <button
                                      type='button'
                                      onClick={addSlot}
                                      className='text-xs font-medium text-everglade-700 hover:underline flex items-center gap-1'
                                    >
                                      <FiPlus size={12} /> Add slot
                                    </button>
                                  </div>

                                  {daySlots.length === 0 ? (
                                    <span className='text-sm text-gray-400 italic'>
                                      Not available
                                    </span>
                                  ) : (
                                    <div className='flex flex-col gap-2'>
                                      {daySlots.map((slot) => (
                                        <div
                                          key={slot.id}
                                          className='flex items-center gap-2 flex-wrap'
                                        >
                                          <select
                                            value={slot.start}
                                            onChange={(e) =>
                                              updateSlot(slot.id, 'start', e.target.value)
                                            }
                                            className='border border-gray-300 rounded-md px-2 py-1.5 text-sm text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-everglade-500 focus:border-everglade-500'
                                          >
                                            <option value='' disabled>
                                              Start
                                            </option>
                                            {TIME_OPTIONS.map((option) => (
                                              <option key={option.value} value={option.value}>
                                                {option.label}
                                              </option>
                                            ))}
                                          </select>
                                          <span className='text-gray-400 text-sm'>to</span>
                                          <select
                                            value={slot.end}
                                            onChange={(e) =>
                                              updateSlot(slot.id, 'end', e.target.value)
                                            }
                                            className='border border-gray-300 rounded-md px-2 py-1.5 text-sm text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-everglade-500 focus:border-everglade-500'
                                          >
                                            <option value='' disabled>
                                              End
                                            </option>
                                            {TIME_OPTIONS.map((option) => (
                                              <option key={option.value} value={option.value}>
                                                {option.label}
                                              </option>
                                            ))}
                                          </select>
                                          <button
                                            type='button'
                                            onClick={() => removeSlot(slot.id)}
                                            className='text-gray-400 hover:text-red-600'
                                          >
                                            <FiTrash2 size={14} />
                                          </button>
                                          {slotErrors[slot.id] && (
                                            <span className='text-xs text-red-600 flex items-center gap-1'>
                                              <FiAlertTriangle size={12} />{' '}
                                              {slotErrors[slot.id]}
                                            </span>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              )
                            })}
                          </div>

                          <p className='text-xs text-gray-400 mt-3'>
                            Patient messages and routine notifications are only
                            expected during these slots — outside them, the
                            practitioner is treated as offline.
                          </p>
                        </div>
                        <p className='text-xs text-gray-400 mt-2'>
                          These fields won't be saved with the rest of the
                          form via "Save changes" so please save it here.
                        </p>
                      </div>
                    )}
                </div>
                )}
                {activeTab === 'address' && (
                   <div className='p-6'>
                      <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4'>
                        Practice address
                      </p>
                      <div className='grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4'>
                        <div className='relative z-50'>
                          <InputFloatingLabel
                            name='address_line1'
                            label='Address line 1'
                            placeholder={
                              showAddressHint
                                ? 'Type at least 3 characters...'
                                : ' '
                            }
                            onChange={(e) =>
                              handleAddressChange(e, setFieldValue)
                            }
                            onFocus={() => {
                              setShowAddressHint(true)
                              if (values.address_line1?.length > 2)
                                setShowSuggestions(true)
                            }}
                            onBlur={(e) => {
                              handleBlur()
                              setShowAddressHint(false)
                              setTimeout(() => setShowSuggestions(false), 200)
                            }}
                          />

                          {isSearching && (
                            <div className='absolute right-3 top-2.5 pointer-events-none'>
                              <AiOutlineLoading3Quarters
                                className='animate-spin text-everglade-700'
                                size={18}
                              />
                            </div>
                          )}

                          {showSuggestions &&
                            suggestions.length > 0 &&
                            !isSearching && (
                              <ul className='absolute top-[100%] left-0 w-full bg-white border border-gray-200 rounded-md shadow-lg mt-1 max-h-60 overflow-y-auto z-[100]'>
                                {suggestions.map((s) => (
                                  <li
                                    key={s.properties.place_id}
                                    className='p-3 hover:bg-everglade-100 border-b border-gray-100 cursor-pointer text-sm text-gray-700'
                                    onMouseDown={() => {
                                      const props = s.properties
                                      setFieldValue(
                                        'address_line1',
                                        props.address_line1 ||
                                          props.street ||
                                          props.formatted.split(',')[0] ||
                                          ''
                                      )
                                      setFieldValue(
                                        'address_city',
                                        props.city || ''
                                      )
                                      setFieldValue(
                                        'address_state',
                                        props.state || props.state_code || ''
                                      )
                                      setFieldValue(
                                        'address_zip',
                                        props.postcode || ''
                                      )
                                      setShowSuggestions(false)
                                    }}
                                  >
                                    {s.properties.formatted}
                                  </li>
                                ))}
                              </ul>
                            )}
                        </div>

                        <InputFloatingLabel
                          name='address_line2'
                          label='Address line 2'
                        />
                        <InputFloatingLabel
                          name='address_state'
                          label='Address state'
                        />
                        <InputFloatingLabel
                          name='address_city'
                          label='Address city'
                        />
                        <InputFloatingLabel
                          name='address_zip'
                          label='Zip code'
                        />
                      </div>
                    </div>
                  // <div className='p-6'>
                  //   <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4'>
                  //     Practice address
                  //   </p>
                  //   <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                  //     <div className='relative z-50'>
                  //       <InputFloatingLabel
                  //         name='address_line1'
                  //         label='Address line 1'
                  //         placeholder={
                  //           showAddressHint
                  //             ? 'Type at least 3 characters...'
                  //             : ' '
                  //         }
                  //         onChange={(e) => handleAddressChange(e, setFieldValue)}
                  //         onFocus={() => {
                  //           setShowAddressHint(true)
                  //           if (values.address_line1?.length > 2)
                  //             setShowSuggestions(true)
                  //         }}
                  //         onBlur={() => {
                  //           setShowAddressHint(false)
                  //           setTimeout(() => setShowSuggestions(false), 200)
                  //         }}
                  //       />

                  //       {isSearching && (
                  //         <div className='absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none'>
                  //           <AiOutlineLoading3Quarters
                  //             className='animate-spin text-everglade-700'
                  //             size={20}
                  //           />
                  //         </div>
                  //       )}

                  //       {showSuggestions &&
                  //         suggestions.length > 0 &&
                  //         !isSearching && (
                  //           <ul className='absolute top-[100%] left-0 w-full bg-white border border-gray-200 rounded-md shadow-lg mt-1 max-h-60 overflow-y-auto z-[100]'>
                  //             {suggestions.map((s) => (
                  //               <li
                  //                 key={s.properties.place_id}
                  //                 className='p-3 hover:bg-everglade-100 border-b border-gray-100 cursor-pointer text-sm text-gray-700'
                  //                 onMouseDown={() => {
                  //                   const props = s.properties
                  //                   setFieldValue(
                  //                     'address_line1',
                  //                     props.address_line1 ||
                  //                       props.street ||
                  //                       props.formatted.split(',')[0] ||
                  //                       ''
                  //                   )
                  //                   setFieldValue('address_city', props.city || '')
                  //                   setFieldValue(
                  //                     'address_state',
                  //                     props.state || props.state_code || ''
                  //                   )
                  //                   setFieldValue(
                  //                     'address_zip',
                  //                     props.postcode || ''
                  //                   )
                  //                   setShowSuggestions(false)
                  //                 }}
                  //               >
                  //                 {s.properties.formatted}
                  //               </li>
                  //             ))}
                  //           </ul>
                  //         )}
                  //     </div>

                  //     <InputFloatingLabel
                  //       name='address_line2'
                  //       label='Address line 2'
                  //     />
                  //     <InputFloatingLabel
                  //       name='address_state'
                  //       label='Address state'
                  //     />
                  //     <InputFloatingLabel
                  //       name='address_city'
                  //       label='Address city'
                  //     />
                  //     <InputFloatingLabel name='address_zip' label='Zip code' />
                  //   </div>
                  // </div>
                )}


                {activeTab === 'system' && (
                  <div className='p-6 grid grid-cols-1 md:grid-cols-2 gap-4 text-sm'>
                    <Row label='Practitioner ID' value={docinfo?.id} />
                    <Row
                      label='Practitioner reference'
                      value={doctorDetails?.data?.doctor_login?.practitioner_id}
                    />
                    <Row
                      label='Sendbird ID'
                      value={sdk?.currentUser?.userId || '—'}
                    />
                    <Row label='Email' value={docinfo?.email_address} breakAll />
                  </div>
                )}

                {(activeTab=== 'address' || activeTab==='personal')  && (
                  <div className='px-6 pb-6'>
                  <button
                    type='submit'
                    className='border-2 mt-3 w-[153px] h-14 rounded border-everglade-700 bg-everglade-700 hover:border-everglade-400 hover:bg-everglade-400 uppercase flex items-center justify-center text-sm poppins font-medium text-white'
                  >
                    {updateDetails?.loading ? 'Loading..' : 'Submit'}
                  </button>
                </div>
                )}
                {(activeTab=== 'availablity' ) && !availabilityState.showAvailabilityOnboarding  && (
                  <div className='px-6 pb-6'>
                  <button type='button'
                    disabled={isSavingAvailability}
                    onClick={()=>saveAvailablity(values)}
                    className='border-2 mt-3 w-[153px] h-14 rounded border-everglade-700 bg-everglade-700 hover:border-everglade-400 hover:bg-everglade-400 uppercase flex items-center justify-center text-sm poppins font-medium text-white disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:border-everglade-700 disabled:hover:bg-everglade-700'
                  >
                    {isSavingAvailability ? 'Saving…' : 'Save Availability'}
                  </button>
                </div>
                )}
              </Form>)
            }}
          </Formik>
        </div>
      </div>

      {openModal && (
        <Modal
          title={'Upload profile picture'}
          close={() => setOpenModal(false)}
        >
          <UplaodProfile
            close={() => setOpenModal(false)}
            setFile={setFile}
            setImageUrl={setImageUrl}
          />
        </Modal>
      )}

      {previewOpen && (
        <Modal title={'Profile card preview'} close={() => setPreviewOpen(false)}>
          <div className='w-full rounded-lg overflow-hidden border border-gray-200'>
            <div className='w-full py-8 bg-gradient-to-b to-everglade-200 from-everglade-700 flex flex-col justify-center items-center'>
              {!imageUrl && !doctorDetails?.data?.profile_image ? (
                <Avatar
                  fname={firstName}
                  lname={secondName}
                  width={'w-[120px] h-[120px] text-xl'}
                />
              ) : (
                <Avatar
                  image={imageUrl || doctorDetails?.data?.profile_image}
                  width={'w-[120px] h-[120px] text-xl'}
                  profile={true}
                />
              )}
              <h1 className='text-white font-bold tracking-wide text-lg capitalize mt-3'>
                {docinfo?.name}
              </h1>
              <p className='text-everglade-100 text-sm capitalize'>
                {doctorDetails?.data?.speciality || 'Practitioner'}
              </p>
            </div>
            <div className='p-4 flex flex-col gap-2 text-sm bg-white'>
              <Row label='Practitioner ID' value={docinfo?.id} />
              <Row label='Email' value={docinfo?.email_address} breakAll />
              <Row label='Phone' value={docinfo?.location?.phone_number} />
            </div>
          </div>
        </Modal>
      )}
      {show && 
      <Modal className="mt-0 shadow-2xl" title="Add Predefined Message" onClick={()=>setShow(false)} close={()=>setShow(false)}>
         <AddPredefinedMessage  row={row} edit={false} url={doctorDetails?.data?.replacement_url} close={()=>{setShow(false);setRow("")}}/>
      </Modal>
      }

    </div>
  )
}




export default Profile